(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('infoModal', infoModal);

    /* @ngInject */
    function infoModal() {
        var directive = {
            bindToController: true,
            templateUrl: 'info-modal.tpl',
            controller: infoModalController,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.vm.simpleCase = !scope.$root.jump2Checkout && !scope.$root.is_askNumber;
            // console.log(scope.vm.simpleCase);
            if (scope.vm.simpleCase) {
                setTimeout(scope.$root.modalClose, 1100);
            }
        }
    }

    /* @ngInject */
    function infoModalController ($scope) {
        $scope.close = function() {
            $scope.$root.jump2Checkout = null;
            $scope.$root.whatAdded = '';
            setTimeout($scope.$root.modalClose, 1);
        };

        $scope.checkout = function() {
            $scope.$root.$broadcast("next-fold", {from: 'pies', to: 'source' });
            $scope.close();
        };
        $scope.vm.infoText =   $scope.$root.whatAdded ? $scope.$root.whatAdded + ' added' : 'Added';
    }
})();